<template>
  <div style="margin-right: 10px">
    <sc-btn :handler="toggle" v-show="modelValue" icon="DownOutlined"/>
    <sc-btn
      type="primary"
      :handler="toggle"
      v-show="!modelValue"
      icon="SearchOutlined"
    />
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
}>();

function toggle() {
  emit("update:modelValue", !props.modelValue);
}

</script>
